var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PAGE_TYPE } from '@marketing/blog/types';
import BlogTile from '@marketing/components/global/tile/BlogTile';
import Heading from '@marketing/components/global/typography/Heading';
import { useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link, useRouteLoaderData } from 'react-router';
var RECENT_ARTICLES_PAGE_SIZE = 2;
function BlogPostList() {
    var isMobile = useMediaQuery('(max-width: 768px)');
    var Butter = useRouteLoaderData('root').Butter;
    var _a = useState([]), recentArticles = _a[0], setRecentArticles = _a[1];
    useEffect(function () {
        var pageParams = {
            alt_media_text: 1,
            page_size: RECENT_ARTICLES_PAGE_SIZE, // Always fetch 2 articles
        };
        Butter.page
            .list(PAGE_TYPE, pageParams)
            .then(function (response) {
            if (response.data) {
                setRecentArticles(response.data.data);
            }
        })
            .catch(function (error) {
            console.error('Error fetching recent articles:', error);
        });
    }, []);
    return (_jsxs("div", __assign({ className: "flex flex-col justify-start items-start gap-xs-d shrink-0 w-full md:w-auto" }, { children: [_jsx(Heading, __assign({ tabbable: true, size: "sm", className: "text-text-body" }, { children: "From The Blog" })), _jsx("div", __assign({ className: "flex justify-start gap-5 w-full md:w-auto overflow-x-auto" }, { children: recentArticles.slice(0, isMobile ? 1 : 2).map(function (_a) {
                    var fields = _a.fields, slug = _a.slug;
                    return (_jsx(Link, __assign({ to: "/learn/article/".concat(slug), viewTransition: true, className: "w-full md:w-auto hover:no-underline no-underline" }, { children: _jsx(BlogTile, { imgSrc: fields.hero_image.url, title: fields.h1 }) }), slug));
                }) }))] })));
}
export default BlogPostList;
